export const mediaQuery = {
  sp: '(max-width: 768px)',
  tablet: '(min-width: 768px) and (max-width: 1121px)',
};
